const StudiesDataSortOptions = Object.freeze({
    LASTLOGIN: 'lastLogin',
    COMPANYNAME: 'companyName',
});

export default StudiesDataSortOptions;
